import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateService from "./UpdateService";
import { config } from "../../../config";
import imageCompression from 'browser-image-compression';


const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const ViewService = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingService, setEditingService] = useState(null);
  const [photo, setPhoto] = useState("");
  const [membershipsForServices, setMembershipsForServices] = useState([]);
  const [compressedImage, setCompressedImage] = useState(null);

  const [formData, setFormData] = useState({
    service_name: "",
    image: null,
    description: "",
    duration: "",
    selling_price: "",
    discount_price: "",
    membership_type: "",
  });

  // Fetch services from API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${apiUrl}/services`);
        setServices(response.data.services);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching services:", err);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

   useEffect(() => {
    const fetchMemberships = async () => {
      try {
        const response = await axios.get(`${apiUrl}/memberships`);
          
        setMembershipsForServices(response.data);
      } catch (err) {
        console.error("Error fetching services:", err);
      }
    };

    fetchMemberships();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      try {
        await axios.delete(`${apiUrl}/servicedelete/${id}`);
        setServices((prev) => prev.filter((service) => service.id !== id));
      } catch (err) {
        console.error("Error deleting service:", err);
      }
    }
  };

  const handleEditClick = (service) => {
    if (editingService === service.id) {
      setEditingService(null);
    } else {
      setEditingService(service.id);
      setFormData({
        service_name: service.service_name,
        image: service.image,
        description: service.description,
        duration: service.duration,
        selling_price: service.selling_price,
        discount_price: service.discount_price,
        membership_type: service.membership_type,
      });
    }
  };

  // Handle Input Changes
 const handleChange = async (e) => {
  const { name, value, files } = e.target;
  
  if (name === "image" && files && files[0]) {
    const file = files[0];
    try {
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
        fileType: 'image/webp'
      };

      const compressedFile = await imageCompression(file, options);
      const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
      const finalFile = new File([compressedFile], fileName, {
        type: "image/webp",
        lastModified: Date.now()
      });

      setCompressedImage(finalFile); // photo স্টেটে সেট করুন
      setFormData(prev => ({ ...prev, [name]: finalFile }));
    } catch (error) {
      console.error("Image compression error:", error);
    }
  } else {
    setFormData(prev => ({ ...prev, [name]: value }));
  }
};

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      description: value || "",
    }));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingService) {
      setError("No service selected for editing.");
      return;
    }

    const data = new FormData();
    data.append("_method", "PUT");
    if (compressedImage) data.append("image", compressedImage);

    data.append("service_name", formData.service_name);
    data.append("description", formData.description);
    data.append("duration", formData.duration);
    data.append("selling_price", formData.selling_price);
    data.append("discount_price", formData.discount_price);
    data.append("membership_type", formData.membership_type);

    try {
      await axios.post(`${apiUrl}/servicesupdate/${editingService}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Service updated successfully");

      setServices((prev) =>
        prev.map((service) =>
          service.id === editingService
            ? { ...service, ...formData, image: photo }
            : service
        )
      );

      setEditingService(null);
    } catch (err) {
      console.error("Error updating service:", err?.response?.data?.message);
      setError("An error occurred while updating the service.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Service List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Image</th>
            <th className="border border-gray-300 px-4 py-2">Service Name</th>
            <th className="border border-gray-300 px-4 py-2">Description</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {services.map((service) => (
            <tr key={service.id}>
              <td className="border border-gray-300 px-4 py-2 text-center">
                <img
                  src={`${imageUrl}/${service.image}`}
                  alt={service.service_name}
                  height={60}
                  width={60}
                />
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {service.service_name}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {service.description}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                <button
                  onClick={() => handleEditClick(service)}
                  className="bg-yellow-400 text-white px-4 py-1 rounded mx-2"
                >
                  {editingService === service.id ? "Cancel Edit" : "Edit"}
                </button>
                <button
                  onClick={() => handleDelete(service.id)}
                  className="bg-red-500 text-white px-4 py-1 rounded mx-2"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingService && (
        <UpdateService
          formData={formData}
          handleQuillChange={handleQuillChange}
          membershipsForServices={membershipsForServices}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          setPhoto={setPhoto}
          loading={loading}
          error={error}
        />
      )}
    </div>
  );
};

export default ViewService;
